module.exports = __webpack_public_path__ + "static/img/5.f3b6b6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/5.png
// module id = 4Vqf
// module chunks = 0